export const CLAIM_FILING_GET = 'CLAIM_FILING_GET'
export const CLAIM_FILING_GET_SUCCESS = 'CLAIM_FILING_GET_SUCCESS'
export const CLAIM_FILING_GET_FAILED = 'CLAIM_FILING_GET_FAILED'

export const CLAIM_FILING_DOWNLOAD_REPORT = 'CLAIM_FILING_DOWNLOAD_REPORT'
export const CLAIM_FILING_DOWNLOAD_REPORT_SUCCESS = 'CLAIM_FILING_DOWNLOAD_REPORT_SUCCESS'
export const CLAIM_FILING_DOWNLOAD_REPORT_FAILED = 'CLAIM_FILING_DOWNLOAD_REPORT_FAILED'